//Base URL of API

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AZ_SEARCH = process.env.REACT_APP_AZURE_SEARCH;

//Authentication & Registeration Endpoints

export const LOGIN = 'accounts/login/';
export const REGISTERUSER = 'accounts/newuser/';
export const LOGINUSER = 'accounts/auth/login/';
export const REFRESHTOKEN = 'accounts/auth/login/refresh/';
export const AZURE_REGISTER = 'accounts/auth/azure-register/';
export const COMPLETE_PROFILE = 'accounts/auth/complete-profile/';
export const REGISTER_USER = 'accounts/register/'; //new
export const RESEND_ACTIVATION_LINK = 'accounts/auth/users/resend_activation/';
export const ACTIVATE_ACCOUNT = 'accounts/auth/users/activation/';
export const FORGOT_PASSWORD = 'accounts/users/reset_password/';
export const CHANGE_PASSWORD = 'accounts/users/reset_password_confirm/';
export const CHANGE_PASSWORD_SETTINGS = 'accounts/settings/change_password/';
export const TOKEN_REFRESH = 'accounts/auth/login/refresh/';
/** POST with Bearer token — records workspace audit ``user_logged_out`` then client clears JWT */
export const AUTH_LOGOUT = 'accounts/auth/logout/';
export const REQUEST_INVITE = 'accounts/invitations/request_new_account/';
/** GET accounts/invitations/validate-invite/:key/ */
export const VALIDATE_INVITE = 'accounts/invitations/validate-invite/';
// export const TOKEN_REFRESH = 'accounts/login/refresh/';
export const DOC_PROJECT = 'projects/project/';
export const DUPLICATE_PROJECT = id => `projects/project/${id}/duplicate/`;
export const DUPLICATE_PROJECT_JOB = jobId => `projects/project/duplicate-jobs/${jobId}/`;
export const PROJECT_ADD_INVESTOR = '/projects/projects_investor/';
export const NDA_DOC = 'dataroom/documents_NDA/';
export const IRL_DOC = '/dataroom/documents_IRL/';
/** GET …/documents_IRL/{project_id}/{ws_id}/lightweight/ — Ask AI scope catalog (no Azure merge). */
export const irlDocLightweight = (projectId, wsId) => `/dataroom/documents_IRL/${projectId}/${wsId}/lightweight/`;
/** GET …/documents_IRL/{project_id}/{ws_id}/index_status/?file_ids=1,2 — RAG indexer readiness. */
export const irlDocIndexStatus = (projectId, wsId, fileIds) =>
    `/dataroom/documents_IRL/${projectId}/${wsId}/index_status/?file_ids=${(fileIds || []).join(',')}`;
/** POST …/documents_IRL/{project_id}/{ws_id}/retry_index/ — re-trigger Azure indexers for files. */
export const irlDocRetryIndex = (projectId, wsId) =>
    `/dataroom/documents_IRL/${projectId}/${wsId}/retry_index/`;

/** AI Warden multi-workstream scope endpoints (project-level). */
export const AI_WARDEN_FILTERS = projectId => `dataroom/ai_warden/${projectId}/filters/`;
export const AI_WARDEN_DOCS_LIGHTWEIGHT = projectId => `dataroom/ai_warden/${projectId}/documents/lightweight/`;
export const AI_WARDEN_FOLDERS_LIGHTWEIGHT = projectId => `dataroom/ai_warden/${projectId}/folders/lightweight/`;
export const AI_WARDEN_IRL_LIGHTWEIGHT = projectId => `dataroom/ai_warden/${projectId}/irl/lightweight/`;
export const AI_WARDEN_OBS_LIGHTWEIGHT = projectId => `dataroom/ai_warden/${projectId}/observations/lightweight/`;

export function aiWardenWorkstreamQuery(workstreamIds) {
    if (!workstreamIds?.length) return '';
    const params = new URLSearchParams();
    for (const id of workstreamIds) {
        params.append('workstream_ids', String(id));
    }
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}

/** POST intelligence/projects/{project_id}/ask/ — federated VDR+IRL ask (Phase 3A). */
export const INTELLIGENCE_ASK = projectId => `intelligence/projects/${projectId}/ask/`;
/** POST intelligence/projects/{project_id}/debug/ask/ — internal developer playground. */
export const INTELLIGENCE_DEBUG_ASK = projectId => `intelligence/projects/${projectId}/debug/ask/`;
/** POST intelligence/projects/{project_id}/feedback/ — structured answer feedback. */
export const INTELLIGENCE_FEEDBACK = projectId => `intelligence/projects/${projectId}/feedback/`;
/** Ask AI conversations (persisted chat history). */
export const INTELLIGENCE_CONVERSATIONS = projectId => `intelligence/projects/${projectId}/conversations/`;
export const INTELLIGENCE_CONVERSATION = (projectId, conversationId) =>
    `intelligence/projects/${projectId}/conversations/${conversationId}/`;
export const INTELLIGENCE_CONVERSATION_MESSAGES = (projectId, conversationId) =>
    `intelligence/projects/${projectId}/conversations/${conversationId}/messages/`;
/** GET intelligence/projects/{project_id}/insights/ — stored Lens Intelligence Insights. */
export const INTELLIGENCE_INSIGHTS = projectId => `intelligence/projects/${projectId}/insights/`;
/** POST intelligence/projects/{project_id}/insights/{key}/regenerate/ */
export const INTELLIGENCE_INSIGHT_REGENERATE = (projectId, insightKey) => `intelligence/projects/${projectId}/insights/${insightKey}/regenerate/`;
/** GET Intelligence Insights V2 Overview (screens.overview). */
export const INTELLIGENCE_INSIGHTS_V2_OVERVIEW = projectId =>
    `intelligence/projects/${projectId}/insights/v2/overview/`;
/** POST generate a new immutable analysis version. */
export const INTELLIGENCE_INSIGHTS_V2_GENERATE = projectId =>
    `intelligence/projects/${projectId}/insights/v2/generate/`;
/** GET analysis version history. */
export const INTELLIGENCE_INSIGHTS_V2_VERSIONS = projectId =>
    `intelligence/projects/${projectId}/insights/v2/versions/`;
/** GET/POST Intelligence Insights V2 Highlights module. */
export const INTELLIGENCE_INSIGHTS_V2_HIGHLIGHTS = projectId =>
    `intelligence/projects/${projectId}/insights/v2/highlights/`;
/** GET Universal Evidence Panel for a Highlights card area. */
export const INTELLIGENCE_INSIGHTS_V2_HIGHLIGHTS_EVIDENCE = (projectId, area) =>
    `intelligence/projects/${projectId}/insights/v2/highlights/evidence/?area=${encodeURIComponent(area)}`;
/** GET Universal Evidence Panel for any controlled scope area (Management Summary, etc.). */
export const INTELLIGENCE_INSIGHTS_V2_SCOPE_EVIDENCE = (projectId, scopeArea) =>
    `intelligence/projects/${projectId}/insights/v2/evidence/?scope_area=${encodeURIComponent(scopeArea)}`;
/** GET Universal Evidence Panel for a selected canonical object (takeaway origin, finding, risk…). */
export const INTELLIGENCE_INSIGHTS_V2_OBJECT_EVIDENCE = (projectId, objectType, objectId) =>
    `intelligence/projects/${projectId}/insights/v2/evidence/?object_type=${encodeURIComponent(
        objectType,
    )}&object_id=${encodeURIComponent(objectId)}`;
/** GET screens.<module_key> persisted module payload (MS → Evidence). */
export const INTELLIGENCE_INSIGHTS_V2_MODULE = (projectId, moduleKey) =>
    `intelligence/projects/${projectId}/insights/v2/modules/${moduleKey}/`;
/** POST human review of a remediation treatment estimate. */
export const INTELLIGENCE_INSIGHTS_V2_REMEDIATION_ESTIMATE_REVIEW = (projectId, treatmentId) =>
    `intelligence/projects/${projectId}/insights/v2/remediation/${encodeURIComponent(treatmentId)}/estimate/review/`;
export const DATAROOM_SHARE = '/dataroom/share/';
export const DATAROOM_SHARED_RESOLVE = '/dataroom/shared/';
export const SAS_API = 'dataroom/sasAPI/';
export const NOTIFICATIONS = 'accounts/inbox/notifications/get_all';
export const REMOVE_NOTIFICATION = '/accounts/inbox/notifications/delete_one/';
export const READ_NOTIFICATION = '/accounts/inbox/notifications/read_one/';
export const PROJECTSCOPE = 'projectscopes/projectscope/';
export const USERMINFO = '/accounts/userinfo/';
export const MY_WORKSPACES = '/accounts/workspaces/';
export const EMAIL_PREFERENCES_ALL = '/accounts/email-preferences/all/';
export const USER_PROFILE = '/accounts/me/';
export const REPORT_BROWSER_TIMEZONE = '/accounts/me/report-timezone/';
export const SUGGEST_RESPONSIBILITIES = '/accounts/me/suggest-responsibilities/';
export const TENT_MEMBERS = projectId => `${DOC_PROJECT}${projectId}/tent/`;
export const TENT_SEND_EMAIL = projectId => `${DOC_PROJECT}${projectId}/tent/email/`;
export const EMAIL_PREFERENCES_PROJECT = '/accounts/email-preferences/project/';
export const PULSE_PREFERENCES = '/pulse/preferences/';
export const PULSE_PREFERENCES_DETAIL = workspaceId => `/pulse/preferences/${workspaceId}/`;
export const PULSE_ME = '/pulse/me/';
export const WORKSPACE_PULSE_ADMIN = workspaceId => `accounts/workspaces/${workspaceId}/admin/workspace-pulse/`;
export const WORKSPACE_PULSE_RECIPIENTS = workspaceId => `accounts/workspaces/${workspaceId}/admin/workspace-pulse/recipients/`;
export const WORKSPACE_PULSE_GENERATE = workspaceId => `accounts/workspaces/${workspaceId}/admin/workspace-pulse/generate/`;
export const WORKSPACE_PULSE_SCREEN = '/pulse/workspace-pulse/';
export const WORKSPACE_PULSE_ACCESS = '/pulse/workspace-pulse/access/';
export const PS_ITEMS_LIST = 'projectscopes/projectscopes_items_list';
export const PS_ITEMS = 'projectscopes/projectscopes_items/';
export const IRL_ITEMS = 'dataroom/workstream_folders/';
export const DATAROOM_WORKSTREAM = '/dataroom/workstream/';
export const ALERTS = 'projects/project/projects_alerts/';
export const NOTES = '/tools/notepad/';
export const NOTE = '/tools/notes/';
export const JOURNAL_ANALYSIS = projectId => `/tools/journal-analysis/${projectId}/`;
export const JOURNAL_ANALYSIS_CHAT = (projectId, chatId) => `/tools/journal-analysis/${projectId}/${chatId}/`;
export const JOURNAL_ANALYSIS_MESSAGES = (projectId, chatId) => `/tools/journal-analysis/${projectId}/${chatId}/messages/`;
export const JOURNAL_ANALYSIS_SEND = (projectId, chatId) => `/tools/journal-analysis/${projectId}/${chatId}/send/`;
export const JOURNAL_ANALYSIS_PROMPTS = '/tools/journal-analysis-prompts/';
export const JOURNAL_ANALYSIS_PROMPT = id => `/tools/journal-analysis-prompts/${id}/`;
export const DEFAULT_QUESTION_BANK = '/defaults/default_question_bank/';
export const DEFAULT_WORKSTREAMS = '/defaults/default_workstreams';
export const DEFAULT_FOLDERS = '/defaults/default_ws_folders/';

// export const ALERTS = 'projects/alertsAPI/';

//Project_Propposal
export const PROJECT_PROPOSAL = '/projectscopes/proposal/';
//Journal
export const SCHEDULER_JOURNAL = '/scheduler/journal/';
export const SCHEDULER_JOURNAL_ENTRY = '/scheduler/journal_entry/';
export const SCHEDULER_JOURNAL_ADD_OBSERVATION = '/scheduler/entry_observation/';
export const SCHEDULER_JOURNAL_MANAGEMENT_RES = '/scheduler/question_response/'; // doesn't exist
export const SPEECH_TOKEN = '/scheduler/speech/token/';

//questionBank
export const SCHEDULER_QUESTION_BANK = '/scheduler/question_bank/'; // doesn't exist
export const ADD_MGMT_RESPONSE = '/scheduler/question_bank_bulk/'; // doesn't exist

// 2FA
export const AUTH_QR_CODE = 'accounts/auth/app/activate/';
export const AUTH_SMS = 'accounts/auth/sms_twilio/activate/';
export const AUTH_CODE_CONFIRMATION = '/accounts/auth/app/activate/confirm/';
export const AUTH_CODE_CONFIRMATION_MOB = 'accounts/auth/sms_twilio/activate/confirm/';
export const AUTH_LOGIN_CODE = '/accounts/auth/login/code/';
// 2FA Setup (Registration)
export const SETUP_2FA = 'accounts/auth/setup-2fa/';
export const GET_QR_CODE = 'accounts/auth/get-qr-code/';
export const SEND_SMS_CODE = 'accounts/auth/send-sms-code/';

//Messages
export const GET_INBOX_MESSAGES = '/messages-drf/inbox/';
export const GET_THREAD_REPLIES = '/messages-drf/message/thread/';
export const POST_SEND_REPLY = '/messages-drf/message/thread/';
export const POST_SEND_NEW_MESSAGE = '/messages-drf/message/thread/';

//NDA

export const GET_DOCUMENT_NDA = '/dataroom/documents_NDA/?project_id=';
export const GET_DOCUMENT_URL = '/dataroom/sasAPI/?ProjectImg=';
export const GET_NDA_SIGNEES = '/dataroom/NDASigneesAPI/';
export const GET_PROJECT_CONSULTANT = '/projects/projects_consultant/';

//Meeting
export const GET_SCHEDULE_DATA = '/scheduler/meeting_schedule/';
export const MEETINGS_LIST = '/scheduler/meeting_item/';

export const ADD_ATTENDEE = '/scheduler/meeting_attendee/';
export const DELETE_ATTENDEE = '/scheduler/meeting_attendee/';
export const GET_ATTENDEES = '/scheduler/meeting_attendee/';

//ProjectScope
export const GET_PROJECT_DELEIVERABLES = '/projectscopes/theme_deliverables/';
export const GET_PROJECT_SCOPE_ITEMS = '/projectscopes/scope_items/';
export const GET_PROJECT_SCOPE_THEMES = '/projectscopes/ps_theme/';
export const DEFAULT_THEMES = '/defaults/default_themes/';

//Observations
export const SCHEDULER_OBSERVATIONS = '/tools/observations/';
export const SCHEDULER_OBSERVATION = '/tools/observation/';
export const SCHEDULER_OBSERVATIONS_TYPE = '/tools/observation_type/';
export const SCHEDULER_OBSERVATIONS_ALL = '/tools/observations_all/';

//Teams
export const INVITE_TEAM = '/dataroom/vdr_invitations/';
export const SEND_TEAM_EMAIL = '/accounts/invitations/create-send-invite/';
export const USER_INVITE = '/accounts/invitations/';
export const PROJECT_USERS_PERMISSIONS = '/projects/project_permissions/';
export const DATAROOM_GROUPS = '/dataroom/groups/';
export const GROUPS = '/dataroom/vdr_group/';
export const GROUPS_PERMISSIONS = '/dataroom/vdr_permissions/';
export const GROUPS_MEMBER_PERMISSIONS = '/dataroom/vdr_group_members/';
export const GROUP_MEMBER = '/dataroom/group_member/';

//Reports
export const GET_REPORT_INFO = '/reports/report_info/';
export const GET_REPORT_SCOPE_OBSERVATION = '/reports/scope_observation/';
export const GET_REPORT_THEME_OBSERVATION = '/reports/theme_observation/';
export const SCOPE_REPORT = '/reports/scope_report/';
export const THEME_REPORT = '/reports/theme_report/';
export const SWOT_REPORT = '/reports/update_swot/';
export const REMEDIATION_REPORT = '/reports/swot_remediation/';
export const PROJECT_REPORT = '/reports/project_report/';
export const CONSULTANT_PERSPECTIVE_REPORT = '/reports/consultant_perspective/';
export const UPDATE_PERSPECTIVE_REPORT = '/reports/update_perspectives/';

export const MNMGT_SUMMARY_REPORT = '/reports/management_summary/';
export const ASSESS_RESULT_REPORT = '/reports/assess_results/';
export const ASSESS_FINDINGS_REPORT = '/reports/assess_findings/';
export const SWOT_ANALYSIS_REPORT = '/reports/swot_item/';
export const HUNDRED_DAY_PLAN_REPORT = '/reports/hundred_dayplan/';
export const REPORTS_REPORT = '/reports/report/';

//Tasks interface APIS
export const TASK_INTERFACE = '/tools/tasks/';
export const DELETE_BULK_TASK = '/tools/tasks_bulk/';
export const TASK_INTERFACE_COMMENTS = '/tools/task_comments/';
export const TASK_ATTACHMENTS = '/tools/task-attachments/';
export const TASK_LINKED_RECORDS = '/tools/task-linked-records/';
export const CATEGORIZED_TASKS = '/tools/categorized-tasks/';
export const SHARE_UPDATE_GENERATE = projectId => `/tools/tasks/${projectId}/share_update/generate/`;
export const SHARE_UPDATE_EMAIL = projectId => `/tools/tasks/${projectId}/share_update/email/`;

// RAID items
export const RAID_ITEMS = '/tools/raid/';
export const PROJECT_RAID_OWNERS = '/tools/project-raid-owners/';
export const RAID_ITEM_COMMENTS = '/tools/raid_comments/';

// Lessons Learnt
export const LESSONS = '/tools/lessons/';
export const PROJECT_LESSON_TAGS = '/tools/project-lesson-tags/';
export const LESSON_COMMENTS = '/tools/lesson_comments/';

// Action Log (toolkit app)
export const ACTION_LOG = '/toolkit/action-log/';
export const PROJECT_ACTION_LOG_WORKSTREAMS = '/toolkit/project-action-log-workstreams/';
export const PROJECT_ACTION_LOG_SOURCES = '/toolkit/project-action-log-sources/';
export const ACTION_LOG_COMMENTS = '/toolkit/action_log_comments/';

export const INFORMATION_REQUESTS = '/dataroom/information_request/';
export const INFORMATION_REQUESTS_DELETE = '/dataroom/information_request_bulk/';
export const INFORMATION_RESPONSE = '/dataroom/irresponse/';
export const MANAGEMENT_QUESTION = '/dataroom/management_question/';
export const MANAGEMENT_RESPONSE = '/dataroom/management_response/';
export const DELETE_MANAGEMENT_RESPONSE = '/dataroom/management_question_bulk/';
export const BULK_INFO_REQ = '/dataroom/information_request_bulk/';
export const STOCK_REQUEST = '/defaults/default_irl/';
export const IRL_COMMENT = '/dataroom/irl_comment/';

//Wizzard
export const WIZARD = 'dataroom/readiness_wizard/';
// Maturity Index
export const MATURITY_INDEX = 'tools/maturity_index/';
// Security Index
export const SECURITY_INDEX = 'tools/securtiy_index/';
export const SECURITY_GOVERNANCE = 'tools/governance_index/';
export const SECURITY_GOVERNANCE_RESPONSE = 'tools/governance_index_response/';

//Team Analyser
export const COMPANY_VALUES = 'tools/company_values/';
export const TEAM_MEMBER_ANALYSIS = 'tools/team_member_analysis/';

//CoreSignal + merged enrichment profile (wizard)
export const COMPANY_DETAIL = 'tools/company_automation/get_info/?company_id=';
export const COMPANY_SEARCH = 'tools/company_automation/search/?website_url=';
export const COMPANY_MERGED_PROFILE = 'tools/company_automation/merged_profile/?website_url=';
// Copilot IRL
export const IRLCoPilot = '/tools/gpt_automation/';

// General ChatGPT-style chat
export const GeneralGPT = '/tools/gpt_general/';

//Software Inventory
export const SOFTWARE_INVENTORY = '/tools/software_inventory/';
